import React from 'react'
import { bool, node, string, oneOf } from 'prop-types'
import classNames from 'classnames'

const Sticky = ({
  className: classNameProp,
  children,
  position,
  useMobileButton,
  ...other
}) => {
  const className = classNames(
    'sticky elevation-2',
    classNameProp,
    {
      'sticky--bottom': position === 'bottom',
      'sticky--top': position === 'top',
      'sticky--mobile-btn': useMobileButton,
    }
  )

  return (
    <div className={className} {...other}>
      { children }
      <style jsx>{`
        .sticky {
          position: fixed;
          width: 100%;
          padding: 12px;
          background-color: #fff;
          z-index: 2;
          &--top {
            top: 0;
          }
          &--bottom {
            bottom: 0;
          }
          &--mobile-btn {
            @media screen and (max-width: 767px) {
              bottom: 72px;
              background-color: transparent;
              box-shadow: none;
              padding: 0;
            }
          }
        }
      `}
      </style>
    </div>
  )
}

Sticky.propTypes = {
  className: string,
  children: node,
  position: oneOf(['bottom', 'top']),
  useMobileButton: bool,
}

Sticky.defaultProps = {
  position: 'bottom',
  useMobileButton: false,
}

export default Sticky
